import React from "react";
import { Modal } from "react-bootstrap";
import LibraryCreateForm from "./LibraryLibraryUploadFileForm";

export default function LibraryUploadFile({
  show,
  onHide,
  onSubmit,
  defaultValues
}) {
  return (
    <>
      <Modal
        size="md"
        show={show}
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>
            {defaultValues.uuid
              ? `Update Folder ${defaultValues.name}`
              : "Upload File"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <LibraryCreateForm
            onSubmit={onSubmit}
            defaultValues={defaultValues}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
